var render, staticRenderFns
import script from "./Debug.vue?vue&type=script&lang=ts&"
export * from "./Debug.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\koen\\workspace\\cf2\\src\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a15be5a')) {
      api.createRecord('3a15be5a', component.options)
    } else {
      api.reload('3a15be5a', component.options)
    }
    
  }
}
component.options.__file = "src/components/Debug.vue"
export default component.exports